"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "AnomalyGroupingController", {
    enumerable: true,
    get: function() {
        return AnomalyGroupingController;
    }
});
const _grouping = require("./grouping");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const GROUPING_CONFIG_STORAGE_KEY = 'perf-grouping-config';
let AnomalyGroupingController = class AnomalyGroupingController {
    hostConnected() {
        this.loadGroupingConfig();
    }
    setConfig(config) {
        this.config = _object_spread({}, config);
        if (this.config.groupBy && Array.isArray(this.config.groupBy)) {
            this.config.groupBy = new Set(this.config.groupBy);
        }
        this.refreshGrouping();
    }
    setAnomalies(anomalies) {
        this.anomalyList = anomalies;
        this.refreshGrouping();
    }
    setRevisionMode(mode) {
        this.config.revisionMode = mode;
        this.refreshGrouping();
    }
    toggleGroupBy(criteria, enabled) {
        if (enabled) {
            this.config.groupBy.add(criteria);
        } else {
            this.config.groupBy.delete(criteria);
        }
        this.refreshGrouping();
    }
    refreshGrouping() {
        this.saveGroupingConfig();
        this.groups = (0, _grouping.groupAnomalies)(this.anomalyList, this.config);
        this.host.requestUpdate();
    }
    loadGroupingConfig() {
        const storedConfig = localStorage.getItem(GROUPING_CONFIG_STORAGE_KEY);
        if (storedConfig) {
            try {
                const parsed = JSON.parse(storedConfig);
                // Need to convert groupBy from array to Set.
                if (parsed.groupBy && Array.isArray(parsed.groupBy)) {
                    parsed.groupBy = new Set(parsed.groupBy);
                }
                this.config = _object_spread({}, this.config, parsed);
            } catch (e) {
                console.error('Failed to parse grouping config from localStorage', e);
                localStorage.removeItem(GROUPING_CONFIG_STORAGE_KEY);
            }
        }
    }
    saveGroupingConfig() {
        // Need to convert Set to array for JSON serialization.
        const configToStore = _object_spread_props(_object_spread({}, this.config), {
            groupBy: Array.from(this.config.groupBy)
        });
        localStorage.setItem(GROUPING_CONFIG_STORAGE_KEY, JSON.stringify(configToStore));
    }
    constructor(host){
        this.groups = [];
        this.config = {
            revisionMode: 'OVERLAPPING',
            groupBy: new Set([
                'BENCHMARK'
            ])
        };
        this.anomalyList = [];
        this.host = host;
        this.host.addController(this);
    }
};
